export const appMode = {
	rta: 'r',
	view: 'v'
};

export type AppMode = typeof appMode[keyof typeof appMode];
